module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fBwAy"))).then(() => parcelRequire('dJXJK'));